import { Action, createAction, props } from '@ngrx/store';

import { ScanFlowRegistrationData } from '../scan-flow.reducer';

export const sendCurrentScanFlowContainerMeasurementData = createAction(
    '[ScanFlow] Send Current Container Measurement Data',
    props<{
        registrationTimestamp: number;
    }>(),
);

export const sendTransformedScanFlowContainerMeasurementData = createAction(
    '[ScanFlow] Send Transformed Container Measurement Data',
    props<{
        onSuccessAction: Action | undefined;
        registrationData: ScanFlowRegistrationData;
        registrationTimestamp: number;
    }>(),
);
